import axios from 'axios';
import axiosUrl from './axios.service';
import authHeader from '../helpers/auth-header';
import AuthService from '../services/auth.service';
import router from '../router';
import store from '../store/index';

const API_URL = axiosUrl.getAxiosUrl();

class MailingService {
  async shareNews(name, organisation, address, id) {
    if (organisation == null || organisation == '') {
      store.commit('grantItems/updateModalError', 'E-mail is verplicht!'),
        store.commit('grantItems/enableModalError');
    }
    if (address == null || address == '') {
      store.commit('grantItems/updateModalError', 'E-mail is verplicht!'),
        store.commit('grantItems/enableModalError');
    }
    if (name == null || name == '') {
      store.commit('grantItems/updateModalError', 'Naam is verplicht!'),
        store.commit('grantItems/enableModalError');
    }

    return await axios
      .post(
        API_URL + '/mailing/shareNews',
        {
          receiverName: name,
          receiverOrganisationName: organisation,
          receiverEmail: address,
          newsId: id,
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        store.commit('news/disableShareNews');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async shareNewsMultiple(
    recipients,
    id
  ) {
    
    const noNull = recipients.filter((doc) => { return Object.values(doc).every(prop => prop !== null)})
    if (noNull.length != recipients.length) {
        store.commit('grantItems/updateModalError', 'Naam, Organisatie, E-mail is verplicht!'),
        store.commit('grantItems/enableModalError');
    }
    return await axios
      .post(
        API_URL + '/mailing/shareNewsMultiple',
        {
          recipients: recipients,
          newsId: id,
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        store.commit('news/disableShareNews');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async shareScheme(email, message, name, organisation, id) {
    if (message == null || message == '') {
      store.commit('grantItems/updateModalError', 'Het bericht is verplicht!'),
        store.commit('grantItems/enableModalError');
    }
    if (email == null || email == '') {
      store.commit('grantItems/updateModalError', 'E-mail is verplicht!'),
        store.commit('grantItems/enableModalError');
    }

    return await axios
      .post(
        API_URL + '/mailing/shareScheme',
        {
          receiverName: name,
          receiverOrganisationName: organisation,
          receiverEmail: email,
          message: message,
          schemeIds: [id],
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        store.commit('grantItems/disableShareGrantItem');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async shareSchemeMultiple(
    recipients,
    message,
    id,
    reportType
  ) {
    if (message == null || message == '') {
      store.commit('grantItems/updateModalError', 'Het bericht is verplicht!'),
        store.commit('grantItems/enableModalError');
    }

    return await axios
      .post(
        API_URL + '/mailing/shareSchemesMultiple',
        {
          recipients: recipients,
          message: message,
          reportType: reportType.value,
          schemeIds: [id],
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        store.commit('grantItems/disableShareGrantItem');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async shareSchemes(
    address,
    message,
    description,
    reportTitle,
    customerName,
    customerAccountName,
    ids
  ) {
    if (message == null || message == '') {
      store.commit(
        'grantItems/updateModalError',
        'The message cannot be empty!'
      ),
        store.commit('grantItems/enableModalError');
    }
    if (address == null || address == '') {
      store.commit('grantItems/updateModalError', 'Email cannot be empty!'),
        store.commit('grantItems/enableModalError');
    }
    return await axios
      .post(
        API_URL + '/mailing/shareScheme',
        {
          receiverName: customerAccountName,
          receiverOrganisationName: customerName,
          receiverEmail: address,
          message: message,
          schemeIds: ids,
          reportTitle: reportTitle,
          reportDescription: description,
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        store.commit('grantItems/disableShareGrantsPage', false);
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async shareSchemesMultiple(
    recipients,
    message,
    description,
    reportTitle,
    ids,
    reportType
  ) {
    if (message == null || message == '') {
      store.commit(
        'grantItems/updateModalError',
        'The message cannot be empty!'
      ),
        store.commit('grantItems/enableModalError');
    }

    return await axios
      .post(
        API_URL + '/mailing/shareSchemesMultiple',
        {
          recipients: recipients,
          message: message,
          schemeIds: ids,
          reportTitle: reportTitle,
          reportDescription: description,
          reportType: reportType.value
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        store.commit('grantItems/disableShareGrantsPage', false);
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
}

export default new MailingService();
